
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/tutorials",
      function () {
        return require("private-next-pages/sub/tutorials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/tutorials"])
      });
    }
  